import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { Avatar, Box, Button, Divider, Grid, IconButton } from '@mui/material';
import { InputV2, InputFormatV2, WidgetV2 } from '../../../components/v2';
import { toBase64 } from '../../../common/base64';
import { masks } from '../../../helpers';
import * as actionsAuth from '../../../store/auth/actions';
import * as selectorsAuth from '../../../store/auth/reducer';

const schema = {
  nome: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  email: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const getBase64 = (image) =>
  image && image.includes('data:image') ? image : `data:image/png;base64,${image}`;

const Perfil = ({ updateProfile, auth }) => {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({});

  useEffect(() => {
    setValues({
      email: auth.email,
      nome: auth.nome,
      telefone: auth.telefone,
      avatar: auth.avatar,
      matricula: auth.matricula,
    });
  }, [auth]);

  const onChangeImg = async (e) => {
    if (e.target.files[0]) {
      const base64 = await toBase64(e.target.files[0]);
      setValues({ ...values, avatar: base64 });
    }
  };

  const onChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onClick = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      updateProfile({ nome: values.nome, telefone: values.telefone, avatar: values.avatar });
    }
  };

  return (
    <WidgetV2 title="Meus Dados">
      <Grid container spacing={2} sx={{ p: 2, pb: 3 }}>
        <Grid size={{ xs: 12 }}>
          <Box display="flex" justifyContent="center">
            <input accept="image/*" id="avatar-upload" type="file" style={{ display: 'none' }} onChange={onChangeImg} />
            <label htmlFor="avatar-upload">
              <IconButton color="primary" component="span">
                <Avatar
                  sx={{ width: 100, height: 110 }}
                  src={values.avatar ? getBase64(values.avatar) : '/images/avatars/default.png'}
                />
              </IconButton>
            </label>
          </Box>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <InputV2 label="Matrícula" value={values.matricula || ''} disabled />
        </Grid>
        <Grid size={{ xs: 8 }}>
          <InputV2
            error={!!(errors && errors.nome)}
            isRequired
            label="Nome"
            name="nome"
            onChange={onChange}
            value={values.nome || ''}
            placeholder="Nome"
          />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <InputV2 label="Login" name="email" disabled value={values.email || ''} />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <InputFormatV2
            label="Telefone"
            format="(##) #####-####"
            onChange={(e) => setValues({ ...values, telefone: masks.removePhoneMask(e.target.value.substring(0, 15)) })}
            value={masks.phoneMask(values.telefone) || ''}
            placeholder="(00) 00000-0000"
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider sx={{ my: 1 }} />
          <Button color="primary" variant="contained" onClick={onClick} sx={{ mt: 1 }}>
            Salvar
          </Button>
        </Grid>
      </Grid>
    </WidgetV2>
  );
};

const mapStateToProps = (state) => ({ auth: selectorsAuth.getAuth(state) });
const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsAuth }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Perfil);
